import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { AuthTokenService } from '../../services/auth0-token.service';
import { MatDialog } from '@angular/material/dialog';
import { EditProfileComponent } from '../../../features/popups/edit-profile/edit-profile/edit-profile.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-header',
    imports: [CommonModule, RouterModule, MatIconModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isMenuOpen = false;
  isProfileMenuOpen = false;
  userName:any = 'UserName!'
  impersonatedUser:any = localStorage.getItem("impersonatedUser") ?? ""
  isAdminPage: boolean = false;

  constructor(private sharedService: SharedService, private router:Router, private Auth0TokenService: AuthTokenService, private dialog: MatDialog) { 
    this.sharedService.username$.subscribe(name => {
      this.userName = name;
    });
  }
ngOnInit(){
if(this.router.url.includes('admin')){
this.isAdminPage = true;
}
}
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }
  logOut(){
    this.Auth0TokenService.logout();
  }
  editProfile(){
const dialogRef = this.dialog.open(EditProfileComponent, {
    width: '700px', 
    disableClose: true, 
    panelClass: 'edit-profile-dialog', // Optional: for custom styling
    data: { /* You can pass current user data here if needed */ }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
    }
  });  }

  redirect(){
      this.router.navigate(['/landing'])
  }
  downloadResourcePdf() {
    let absolutePath = this.router.url.includes('?')? this.router.url.split('?')[0]: this.router.url;
    const url = this.sharedService.resourceURL
    let urlAuditLog = this.extractPath(url,absolutePath)
    this.sharedService.callUserAudit(urlAuditLog);
    fetch(url)  
      .then(res => res.blob())  
      .then(blob => {  
        const blobUrl = window.URL.createObjectURL(blob);  
        const a = document.createElement('a');   
        a.href = blobUrl;  
        a.download = 'DDMOResources.pdf';  
        a.click();   
        window.URL.revokeObjectURL(blobUrl);  
      });  
  }

  extractPath(url:string,routerUrl:any){
    if(!url)return routerUrl;
    try{
      const parsed = new URL(url);
      return this.formatPath(parsed.pathname);
    }
    catch{
      return this.formatPath(url)
    }
  }

  formatPath(path:string):string{
    return path.startsWith('/') ? path: '/' + path;
  }
}
